import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Thunk to create a political party
export const createPoliticalParty = createAsyncThunk(
  'politicalParty/createPoliticalParty',
  async (partyData, { rejectWithValue }) => {
    try {
      const response = await api.post('/political-parties', partyData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to create political party');
    }
  }
);

// Thunk to fetch all political parties
export const fetchPoliticalParties = createAsyncThunk(
  'politicalParty/fetchPoliticalParties',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/political-parties');
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to fetch political parties');
    }
  }
);

// Thunk to update a political party
export const updatePoliticalParty = createAsyncThunk(
  'politicalParty/updatePoliticalParty',
  async ({ id, ...partyData }, { rejectWithValue }) => {
    try {
      const response = await api.put(`/political-parties/${id}`, partyData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.error || 'Failed to update political party');
    }
  }
);

const politicalPartySlice = createSlice({
  name: 'politicalParty',
  initialState: {
    items: [],
    status: 'idle',
    error: null,
    createStatus: 'idle',
    createError: null,
    updateStatus: 'idle',
    updateError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchPoliticalParties.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPoliticalParties.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload || [];
      })
      .addCase(fetchPoliticalParties.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      // Create
      .addCase(createPoliticalParty.pending, (state) => {
        state.createStatus = 'loading';
        state.createError = null;
      })
      .addCase(createPoliticalParty.fulfilled, (state, action) => {
        state.createStatus = 'succeeded';
        state.items.push(action.payload);
      })
      .addCase(createPoliticalParty.rejected, (state, action) => {
        state.createStatus = 'failed';
        state.createError = action.payload;
      })
      // Update
      .addCase(updatePoliticalParty.pending, (state) => {
        state.updateStatus = 'loading';
        state.updateError = null;
      })
      .addCase(updatePoliticalParty.fulfilled, (state, action) => {
        state.updateStatus = 'succeeded';
        const idx = state.items.findIndex(p => p.id === action.payload.id);
        if (idx !== -1) {
          state.items[idx] = action.payload;
        }
      })
      .addCase(updatePoliticalParty.rejected, (state, action) => {
        state.updateStatus = 'failed';
        state.updateError = action.payload;
      });
  },
});

export default politicalPartySlice.reducer; 